import React, { useEffect } from 'react';
import WaterWave from 'react-water-wave';

const path = process.env.PUBLIC_URL

function Article({ title, direction, imgSrc, svgSrc, desc, currentIndex, index, size, link, type, subtitle }) {
  // const wrapChars = (str) => {
  //   const ar = str.split('')
  //   let tmpl = ''
  //   console.log(ar)
  //   ar.forEach((element, index) => {
  //     tmpl = tmpl + `<span style="transition-delay: ${index * 0.1}s">${element}</span>`
  //   });
  //   return tmpl;
  // }

  // useEffect(() => {
  //   var image = new Image;
  //   var newImageSource = "https://s3cdn.wainao.me/react-static/special-reports/run/illus02.png"
  //   image.onload = function() {
  //     image.src = newImageSource;
  //   };
  //   // image.src = newImageSource;
  //   document.body.appendChild(image);
  // }, []);

  return (
    <div className={`article ${direction}`}>
      <WaterWave
        dropRadius={60}
        perturbance={0.05}
        imageUrl={`${path}/${imgSrc}.png`}
        className={`mask ${size} desktop`}
        style={{ visibility: "hidden", pointerEvent: "none"}}
        // crossOrigin="https://admin.wainao.me"
      >
        {({ pause, play }) => (
          <></>
        )}
      </WaterWave>
      <img className="mask" src={`${path}/${imgSrc}.png`} />
      {/* <img className='line' src={`${path}/${svgSrc}.svg`} alt="line" /> */}
      {index === 0 && (
        <svg className={"line line" + index + (currentIndex === index ? " active" : "")} viewBox="0 0 1440 977" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1469_3459)">
        <path d="M0 346.468C170.339 226.776 293.18 251.664 330.306 282.269C376.852 307.772 455.836 287.29 491.91 282.269C527.983 277.248 605.469 277.011 645.324 303.291C698.828 338.571 693.915 410.413 732.678 410.413C764.343 410.413 712.272 365.236 721.759 410.413C728.222 441.192 765.861 449.871 773.079 510.976C780.759 576 762.741 539.625 786.5 671C790.935 695.525 787.171 772.566 743.947 784.764C720.634 791.343 730.564 760.422 743.947 756.5C767.897 749.481 764.945 798.653 766.914 816.611C771.418 857.691 807.068 866.99 802.947 902.965C798.827 938.939 815.158 957.241 958 979.48" stroke="#FF8861" strokeWidth="1" strokeLinecap="round"/>
        </g>
        <defs>
        <clipPath id="clip0_1469_3459">
        <rect width="1440" height="977" fill="white"/>
        </clipPath>
        </defs>
        </svg>
      )}
      {index === 1 && (
        <svg className={"line line" + index + (currentIndex === index ? " active" : "")} viewBox="0 0 1440 977" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1469_114)">
        <path d="M762.042,-5C767.5,21 752.232,70.6631 740.073,93.0952C700.809,165.532 701.277,221.613 733.997,319.753C766.717,417.894 703.146,441.261 762.042,495.939C820.938,550.618 756.159,634.035 928.64,609.733C1101.12,585.432 1188.53,686.377 1295.57,609.733C1402.61,533.09 1433.5,462 1440.5,445" stroke="#FF8861" strokeWidth="1"/>
        </g>
        <defs>
        <clipPath id="clip0_1469_114">
        <rect width="1440" height="977" fill="white"/>
        </clipPath>
        </defs>
        </svg>
      )} 
      {index === 2 && (
        <svg className={"line line" + index + (currentIndex === index ? " active" : "")} viewBox="0 0 1440 977" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1469_3474)">
        <path d="M-0.999654,447.999C58.0007,303.498 187.589,264.502 249,264.502C329,264.502 415.5,264.502 580.446,346.033C601.415,356.398 655.728,367.191 643.427,349.97C631.126,332.749 584.937,325.777 604.064,342.588C623.19,359.4 626.123,360.393 635.062,372.111C701.939,459.773 694.934,493.843 751,546.002C871.057,657.695 649.533,739.834 724.814,795.434C790.057,843.62 730.5,895.5 703.711,915C674.231,936.459 611.7,926.316 657.952,909.095C698.866,893.861 715.343,971.167 891,981.499" stroke="#FF8861" strokeWidth="1"/>
        </g>
        <defs>
        <clipPath id="clip0_1469_3474">
        <rect width="1440" height="977" fill="white"/>
        </clipPath>
        </defs>
        </svg>
      )}    
      {index === 3 && ( 
        <svg className={"line line" + index + (currentIndex === index ? " active" : "")} viewBox="0 0 1440 977" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1469_10161)">
        <path d="M368.5 981.5C470.35 960.939 529.427 907.538 564 879.5C598.573 851.462 633.721 793.848 642.666 770.524C647.266 758.53 627.654 772.709 624.044 767.633C615.921 756.213 673.788 708.217 694.344 686.254C714.901 664.291 674.722 680.646 694.344 652.608C713.967 624.57 756.672 592.869 762.089 580.176C764.567 574.371 770.235 561.263 756.95 566.157C743.664 571.051 765.779 539.27 768.029 533.997C774.611 518.575 789.303 501.655 788.719 484.846C788.719 470.36 771.9 446.995 830.3 419.424C888.701 391.853 823.76 373.16 872.816 341.384C921.872 309.607 1024.19 307.271 994.756 268.017C962.045 224.393 1092.99 266.444 1076.05 228.764C1053.36 178.275 1222.47 244.009 1206.87 205.983C1164 101.5 1455 246 1438 -10" stroke="#FF8861" strokeWidth="1"/>
        </g>
        <defs>
        <clipPath id="clip0_1469_10161">
        <rect width="1440" height="977" fill="white"/>
        </clipPath>
        </defs>
        </svg>
      )}  
      {index === 4 && (
        <svg className={"line line" + index + (currentIndex === index ? " active" : "")} viewBox="0 0 1440 977" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1469M762.042,-5C767.5,21 752.232,70.6631 740.073,93.0952C700.809,165.532 701.277,221.613 733.997,319.753C766.717,417.894 703.146,441.261 762.042,495.939C820.938,550.618 756.159,634.035 928.64,609.733C1101.12,585.432 1188.53,686.377 1295.57,609.733C1402.61,533.09 1433.5,462 1440.5,445_6817)">
        <path d="M582.5 -1C667.5 -0.999779 719.761 267.502 662.058 372.684C604.356 477.866 677.545 437.459 682.374 469.651C682.984 473.72 682.95 495.8 691.763 491.161C718.044 477.329 746.124 459.734 758.684 501.746C772.45 547.789 780.22 594.441 799.315 638.661C807.704 658.089 828.354 675.329 841.653 691.583C861.125 715.383 879.609 739.975 900.721 762.26C918.188 780.697 865.957 768.464 858 766.502C809.208 754.471 773.316 737.618 767 727.502C760.684 717.385 777.619 719.239 787.535 719.239C942.48 719.239 1056.35 802.316 1210.23 819.002C1226.7 820.787 1255.72 829.681 1272.71 822.245C1282.24 818.076 1297.13 814.437 1297.13 803.637C1297.13 785.43 1308.08 765.177 1316.25 749.52C1332.23 718.886 1346.8 687.492 1363.02 656.991C1370.67 642.615 1376.96 626.01 1386.24 612.605C1393.95 601.463 1392.39 621.824 1392.39 625.579C1392.39 634.684 1392.63 643.425 1388.63 651.87C1387.87 653.48 1384.74 642.502 1386.24 631.502C1387.74 620.502 1427.5 530.5 1441 455" stroke="#FF8861" strokeWidth="1" strokeLinecap="round"/>
        </g>
        <defs>
        <clipPath id="clip0_1469_6817">
        <rect width="1440" height="977" fill="white"/>
        </clipPath>
        </defs>
        </svg>
                      
      )}        
      {index === 5 && (
        <svg className={"line line" + index + (currentIndex === index ? " active" : "")} viewBox="0 0 1440 977" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1469_13504)">
        <path d="M-3 476.5C25 286 210.09 233.904 332 233.002C370.962 232.713 345.449 271.359 374.5 278.501C397.461 284.147 418.233 253.303 432.5 257.001C446 260.501 438.167 282.606 446 290.501C453.588 298.15 481.511 275.568 494.5 278.501C510 282.001 492.914 314.689 505.5 319.501C522.5 326.001 536 307.001 552.5 313.001C569 319.001 560 335.001 564.5 366.001C571.729 415.798 626.762 361.43 630.5 392.501C634.508 425.818 624.315 443.358 630.5 461.502C636.685 479.645 689.617 453 697.5 476.5C724 555.5 639 868 839.5 972" stroke="#FF8861" strokeWidth="1"/>
        </g>
        <defs>
        <clipPath id="clip0_1469_13504">
        <rect width="1440" height="977" fill="white"/>
        </clipPath>
        </defs>
        </svg>
      )}   
      <div className='container'>
        <h2 className={currentIndex === index ? "active" : ""}>
          <div className='subtitle'>{subtitle}</div>
          <div dangerouslySetInnerHTML={{ __html: title }} />
          {/* <span dangerouslySetInnerHTML={{ __html: title }} /> */}
        </h2>
        <div className={currentIndex === index ? "content active" : "content"}>
          <p>{desc}</p>
          <a href={link} target='_blank' rel="noreferrer" >{ type === "video" ? "观看短片" : "阅读全文"}</a>
        </div>
      </div>
    </div>
  );
}

export default Article;
